import { Link } from "react-router-dom";
import { UnitCardProps } from "./UnitCard.interface";
import { routes } from "../../shared/router/routes";
import { getFromattedPath } from "../../shared/helpers/utils";
import { useContext, useEffect, useState } from "react";
import { ModuleContext } from "../../shared/providers/module/module.provider";

function UnitCard({ unit, index, moduleId, moduleImage }: UnitCardProps) {
    const { module } = useContext(ModuleContext);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (!module) return;
        const unitProgress = module.unitsProgress?.find((u) => u.id === unit.id);
        
        if (!unitProgress) return;
        
        const numberItems = module.units?.find((u) => u.id === unit.id)?.items.length ?? 1;
        const progress = ((unitProgress?.completedItems ?? 0) / numberItems) * 100;

        setProgress(progress >= 100 ? 100 : progress);
    }, [module, unit]);

    return (
        <Link
            className="card card_unit d-flex gap-1 p-02 pe-1"
            to={`${getFromattedPath(routes.UNIT.path, { moduleId, unitId: unit.id })}`}>
            <figure className="unit_thumbnail" data-index={index}>
                <img src={moduleImage} alt={unit.title} />
            </figure>
            <div className="w-100 d-flex flex-column gap-02">
                <div className="d-flex justify-content-between">
                    <span
                        className={`color-${unit?.tag_color ?? "yellow"}-500 text-bd4-bd text-uppercase`}>
                        {unit.tag}
                    </span>
                    {progress === 100 && (
                        <i className="icon icon-24 icon-Checkmark--filled color-green-500" />
                    )}
                </div>
                <h2 className="lineclamp-1 text-bd2-bd color-neutrals-black">{unit.title}</h2>
            </div>
        </Link>
    );
}

export default UnitCard;
